import React from "react";
import Slider from "react-slick";

function Footer() {
  var settings = {
    // dots: true,
    infinite: true,
    speed: 500,
    arrows: false,
    slidesToShow: 6,
    // autoplay: true,
    // slidesToScroll: 1,
    // autoplaySpeed: 2000,
    autoplay: true,
    autoplaySpeed: 0,
    speed: 8000,
    pauseOnHover: false,
    cssEase: "linear",

    responsive: [
      {
        breakpoint: 1600,
        settings: {
          slidesToShow: 5,
        },
      },
      {
        breakpoint: 1400,
        settings: {
          slidesToShow: 4.4,
        },
      },
      {
        breakpoint: 1200,
        settings: {
          slidesToShow: 4,
        },
      },
      {
        breakpoint: 992,
        settings: {
          slidesToShow: 3,
        },
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 2,
        },
      },
      {
        breakpoint: 576,
        settings: {
          slidesToShow: 1.8,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1.2,
        },
      },
      {
        breakpoint: 380,
        settings: {
          slidesToShow: 0.8,
        },
      },
    ],
  };

  return (
    <div>
      <section>
        <div className="pt120 rightleft">
          <div className="stayLoop  mb-5">
            <div className="loop50">
              <h3>Stay in the loop</h3>
              <p className="pt-sm-3 pt-2">
                Join our mailing list to stay in the loop with our newest
                feature releases, NFT drops, and tips and tricks for navigating
                JOLLY.
              </p>
              <div className="pt-3 d-flex emailSmallScreen">
                <input type="email" placeholder="Your email address" />
                <button>Subscribe</button>
              </div>
            </div>
            <div className="community">
              <h3>Join the community</h3>
              <p className="pt-sm-3 pt-2">
                Join our social media list to stay in the loop with our newest
                feature releases, NFT drops, and tips and tricks for navigating
                JOLLY.
              </p>
              <div className="d-flex gap-2 pt-3">
                <button>
                  <img src="Vector.png" alt="twitter" className="me-2" />
                  <div className="checll">Twitter</div>
                </button>
                <button>
                  <img src="Vector (1).png" alt="twitter" className="me-2" />
                  <div className="checll">Discord</div>
                </button>
              </div>
            </div>
          </div>
        </div>

        <div className="companyShow">
          {/* <div className="companyOutcome"> */}
          {/* <div className="d-flex justify-content-between"> */}

          {/* ********* */}
          <Slider {...settings}>
            <div>
              <img src="image 16.png" alt="stack" />
            </div>

            <div>
              <img src="image 15.png" alt="stack" />
            </div>
            <div>
              <img src="image 19.png" alt="stack" />
            </div>
            <div>
              <img src="image 17.png" alt="stack" />
            </div>
            <div>
              <img src="Group 154.png" alt="stack" />
            </div>
            <div>
              <img src="image 16.png" alt="stack" />
            </div>
            <div>
              <img src="image 12.png" alt="stack" />
            </div>
          </Slider>
          {/* </div> */}
          {/* </div> */}
        </div>
        <div className="mainContainer">
          <div className="footerParent">
            <div className="disc">
              <div >
          <span className="pe-md-4 pe-3 dd">Jolly</span>

                <p className="pt-4">
                  The world’s first and largest digital marketplace for crypto
                  collectibles and non-fungible tokens (NFTs). Buy, sell, and
                  discover exclusive digital items.
                </p>
              </div>
            </div>
            <div className="d-flex justify-content-between itemsNav">
              <div className="footerHead">
                <h6>Marketplace</h6>
                <ul>
                  <li>
                    <a href="#">All NFTs</a>
                  </li>
                  <li>
                    <a href="#">Solana NFTs</a>
                  </li>
                  <li>
                    <a href="#">Art</a>
                  </li>
                  <li>
                    <a href="#">Collectibles</a>
                  </li>
                  <li>
                    <a href="#">Domain Names</a>
                  </li>
                  <li>
                    <a href="#">Music</a>
                  </li>
                  <li>
                    <a href="#">Photography</a>
                  </li>
                  <li>
                    <a href="#">Sports</a>
                  </li>
                </ul>
              </div>
              <div className="footerHead">
                <h6>My Account</h6>
                <ul>
                  <li>
                    <a href="#">Profile</a>
                  </li>
                  <li>
                    <a href="#">Favorites</a>
                  </li>
                  <li>
                    <a href="#">Watchlist</a>
                  </li>
                  <li>
                    <a href="#">My Collections</a>
                  </li>
                  <li>
                    <a href="#">Settings</a>
                  </li>
                </ul>
              </div>
              <div className="footerHead">
                <h6>Resources</h6>
                <ul>
                  <li>
                    <a href="#">Help Center</a>
                  </li>
                  <li>
                    <a href="#">Platform Status</a>
                  </li>
                  <li>
                    <a href="#">Partners</a>
                  </li>
                  <li>
                    <a href="#">Gas-Free Marketplace</a>
                  </li>
                  <li>
                    <a href="#">Taxes</a>
                  </li>
                  <li>
                    <a href="#">Blog</a>
                  </li>
                  <li>
                    <a href="#">Docs</a>
                  </li>
                  <li>
                    <a href="#">Newsletter</a>
                  </li>
                </ul>
              </div>
              <div className="footerHead">
                <h6>Company</h6>
                <ul>
                  <li>
                    <a href="#">About</a>
                  </li>
                  <li>
                    <a href="#">Careers</a>
                  </li>
                  <li>
                    <a href="#">Ventures</a>
                  </li>
                  <li>
                    <a href="#">Grants</a>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
        <div className="footerEnd companyShow mt-3">
          <div className="container">
            <div className="d-flex justify-content-between flex-sm-row flex-column align-items-center">
              <div>
                <p className="m-0">© 2023 JOLLY DIGITAL</p>
              </div>
              <div>
                <p className="m-0">
                  Privacy Policy <span className="pe-2 ps-2">I</span> Terms of
                  Service
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}

export default Footer;
